import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy: React.FC = () => {
  return (
    <>
      <div className='privacy-policy'>
        <span className='heading'>Online Services Privacy Policy</span>
        <p className='paragraph'>
          We recognize that the privacy of your information is important. This Online Services Privacy Policy ("Privacy
          Policy" or "Policy") describes our practices in connection with information we collect through the online and
          mobile websites, platforms, services, and applications that we own or operate and that contain a link to this
          Privacy Policy (collectively, "Online Services").
          <br></br>
          <br></br>
          As used in this Policy, terms such as "we," "us," "our," and "Company" refer to current and future affiliated
          entities, subsidiaries, agents, contractors, or vendors of Optum. Our Online Services are intended for a
          United States audience. Any information you provide, including any personal information, will be transferred
          to and processed by a computer server located within the United States.
          <br></br>
          <br></br>
          By using the Online Services, you consent to our collection, use, disclosure, and storage of information as
          described in this Privacy Policy.
          <br></br>
          <br></br>
          Our Privacy Policy explains:
          <br></br>
          <ul className='paragraph'>
            <li>When This Privacy Policy Applies</li>
            <li>What Information We Collect About You</li>
            <li>How We Use Your Information</li>
            <li>How We Share Your Information</li>
            <li>How to Manage Your Information</li>
            <li>Protecting Your Information</li>
            <li>Children Under 13</li>
            <li>Additional Rights for California Residents</li>
            <li>Privacy State Consumer Notice (optum.com)</li>
            <li>Social Media Disclaimer</li>
            <li>Social Security Number Protection Policy</li>
            <li>Changes to This Policy</li>
            <li>Contact Us</li>
          </ul>
        </p>

        <br></br>

        <span className='heading'>When This Privacy Policy Applies</span>
        <p className='paragraph'>
          Our Policy applies to Online Services that we own or operate and that contain a link to this Privacy Policy.
          Our Policy does not apply to information collected through other means such as by telephone, via Online
          Services that do not link to this Privacy Policy, or in person, although that information may be protected by
          other privacy policies.
          <br></br>
          <br></br>
          Our Policy does not apply to the practices of other companies or other websites or software applications that
          may be linked from or made available through our Online Services. The inclusion of a link on our Online
          Services or the ability to utilize a third-party website or software application through our Online Services
          does not imply that we endorse, or otherwise monitor the privacy or security practices of that third-party
          website or software application or the accuracy of its content, and your use of the third-party website or
          software application is governed by the third-party's privacy policy.
          <br></br>
          <br></br>
          Some of our products and services are regulated by certain state and federal laws, including the Health
          Insurance Portability and Accountability Act ("HIPAA") and the Gramm-Leach-Bliley Act and may have specific
          privacy practices ("Product Privacy Notices") such as a HIPAA Notice of Privacy Practices or other specific
          privacy practices that we want you to be aware. When a Product Privacy Notice exists, the content of the
          Product Privacy Notice applies to your use of the product and service. This Privacy Policy is not intended to
          and does not create any contractual or other legal rights in or on behalf of any party.
        </p>

        <br></br>

        <span className='heading'>What Information We Collect About You</span>
        <p className='paragraph'>
          We may collect two basic types of information through the Online Services: (1) information you provide
          directly to us, and (2) information that is automatically provided to us or collected through your use of our
          Online Services (collectively, “Information”).
          <br></br>
          <br></br>
          Such Information may include information that identifies you such as your full name, telephone number,
          business email address, business postal address, certain account numbers, your User ID that you create or is
          assigned to you, name of your employer, National Provider Identifier number (NPI) and other information
          described in this Privacy Policy.
          <br></br>
          <br></br>
          When you use the Online Services, you may provide certain Information directly to us. For example, you may
          input a telephone number or email address into a webform or enter information into a chat functionality. We
          also may make certain information available to you on the Online Services that we collect from other sources.
          For example, we may pre-populate certain demographic information in an online form or make health or medical
          information viewable on the Online Services that you have provided to us on paper forms or maintained in other
          information systems.
          <br></br>
          <br></br>
          We also may obtain Information that is automatically collected through the Online Services. The automatically
          collected Information may include demographic, de-identified, aggregated, or certain information from your
          device such as technical information about your device, web-browser information, and server log files
          collected by us or provided by you. See Cookies and Tracking for more information on automatically collected
          information.
          <br></br>
          <br></br>
          You may limit the Information you provide or make available to us if you want to; however, that may limit your
          ability to access or use certain functions of the Online Services or to request certain services or
          information.
        </p>

        <br></br>

        <span className='heading'>Mobile Devices and Application</span>
        <p className='paragraph'>
          In addition to the Information identified above, we may collect the following Information:
        </p>

        <br></br>

        <span className='heading'>Information that Identifies You</span>
        <p className='paragraph'>
          <ul className='paragraph'>
            <li>Health, medical, therapy, or financial information;</li>
            <li>Location data such as GPS, Wi-Fi, or carrier network location (see below for more details); and</li>
            <li>
              User files stored on your device, like calendars, photos, and videos, if you grant permission through your
              device settings.
            </li>
          </ul>
        </p>

        <br></br>

        <span className='heading'>What You Do on Your Device</span>
        <p className='pargraph'>
          <ul className='paragraph'>
            <li>
              Camera use. Certain features may have access to your camera if you grant permission in your device
              settings;
            </li>
            <li>Local storage;</li>
            <li>Phone dialer;</li>
            <li>Use of screen, e.g., what points are touched, frequency, etc.; and</li>
            <li>Patterns of app usage.</li>
          </ul>
        </p>

        <br></br>

        <span className='heading'>Device or System Data</span>
        <p className='pargraph'>
          <ul className='pargraph'>
            <li>Mobile Device Identifier, e.g., UDID, Android ID; and</li>
            <li>
              Technical information about your device and system and application software, e.g., type of phone,
              Operating System (OS), and IP address.
            </li>
          </ul>
          We may obtain location data from your device to provide location-related services (e.g., driving directions or
          distance calculation, via the mobile application). You may withdraw consent to use precise, real-time, or
          network location data at any time by turning off the location-based feature on your mobile device or by not
          using any location-based features. If you withdraw your consent, functionality associated with precise,
          real-time, or network location (e.g., navigation) will no longer work.
        </p>

        <br></br>

        <span className='heading'>How We Use Your Information</span>
        <p className='paragraph'>
          We may use your Information:
          <br></br>
          <ul className='pargraph'>
            <li>To respond to an email, chat or other instant message or particular request from you;</li>
            <li>To communicate with you; </li>
            <li>
              To provide you with content, services, and functionality through our Online Services or other services
              that we may offer;{' '}
            </li>
            <li>To process an application for a product or service as requested by you;</li>
            <li>To authenticate you on any portion of our Online Services and with vendors acting on our behalf;</li>
            <li>To administer surveys and promotions;</li>
            <li>To personalize your experience on our Online Services;</li>
            <li>
              To provide you with informational or promotional offers, as permitted by law, that we believe may be
              useful to you, such as information about products or services provided by us or other businesses;
            </li>
            <li>To perform analytics and to improve our products, Online Services, and advertising; </li>
            <li>To facilitate the provision of software updates and product support;</li>
            <li>
              To improve products and other services related to the Online Services or to provide services or
              technologies to you;{' '}
            </li>
            <li>To comply with applicable laws, regulations, and legal process; </li>
            <li>To protect someone's health, safety, or welfare;</li>
            <li>
              To protect our rights, the rights of affiliates or related third parties, or to take appropriate legal
              action, such as to enforce our Terms of Use;
            </li>
            <li>To keep a record of our transactions and communications; and</li>
            <li>
              As otherwise necessary or useful for us to conduct our business, so long as such use is permitted by law
              or for any other purpose with your consent.
            </li>
          </ul>
          We may use Information to contact you through any contact information you provide through our Online Services,
          including any email address, telephone number, cell phone number, or fax number. We may communicate,
          electronically or via telephone with you about your benefit plan, programs, products, or services that are or
          may be available to you in connection with your transactions with us including, but not limited to, Online
          Services updates, account information, general wellness, prescription or appointment reminders, general health
          information, newsletters, and surveys. These electronic communications may contain protected health
          information. You acknowledge and accept that such communications may be sent unencrypted and there is some
          risk of disclosure or interception of the contents of these communications. To learn more about our
          communications practices, please visit our Consumer Communications Notice.
          <br></br>
          <br></br>
          We may, when permitted, combine your Information with other information, whether online or offline, maintained
          or available to us from you or from other sources, such as from our vendors, and we may use and disclose
          combined data for the purpose described in this Section or for internal business purposes. We may, when
          permitted, use and disclose de-identified and aggregated data for any purpose, which may include, without
          limitation, disclosures to third parties for analytics purposes such as evaluating the Online Services and
          providing additional benefits, programs, and services.
        </p>

        <br></br>

        <span className='heading'>How We Share Your Information</span>
        <p className='paragraph'>
          We will only share your Information with third parties as outlined in this Policy and as otherwise permitted
          by law or as permitted with your consent.
          <br></br>
          <br></br>
          We may share Information if all or part of the Company is sold, merged, dissolved, acquired, or disbanded to
          any extent in a similar transaction, or in connection with steps that may need to be taken in anticipation of
          such events.
          <br></br>
          <br></br>
          We may share Information in response to a court order, subpoena, search warrant, or to comply with law or
          regulation. We may cooperate with law enforcement authorities in investigating and prosecuting activities that
          are illegal, violate our rules, or may be harmful to other visitors.
          <br></br>
          <br></br>
          We may also share Information within the Company, including among affiliates, or with our parent company, or
          subsidiaries.
          <br></br>
          <br></br>
          We may share information with your employer for our or their legitimate legal interests.
          <br></br>
          <br></br>
          We may also share Information with other third-party companies with which we have a business relationship or
          hire to perform services on our behalf. For example, we may hire a third-party company to help us send and
          manage email, and we might provide that third-party company with your email address and certain other
          Information for them to send you an email message on our behalf. Similarly, we may hire third-party companies
          to host or operate some of our Online Services and related computers and software applications.
        </p>

        <br></br>

        <span className='heading'>How to Manage Your Information</span>
        <p className='paragraph'>
          Our Online Services may permit you to view your profile, if applicable, and access related Information about
          you and to request changes to such Information. Please remember, however, if we have already disclosed some of
          this Information to third parties, we may not have access to that disclosed information and may not be able to
          force the modification of any Information by the third parties to whom we have made those disclosures.
        </p>

        <br></br>

        <span className='heading'>Communication Preference Management</span>
        <p className='paragraph'>
          Our Online Services may permit you to select how you would like to receive certain communications. We may
          offer mobile applications that enable us to communicate with you through push notifications. Where mobile
          applications are offered, you may be able to manage push notifications in your mobile phone or tablet
          settings. You may also be able to control preview settings in your email applications.
          <br></br>
          If you need additional assistance in opting-out of a communication, please Contact Us for assistance. Please
          be aware that opt-outs may not apply to certain types of communications, such as account status, Online
          Service updates, or other communications.
        </p>

        <br></br>

        <span className='heading'>Cookies and Tracking</span>
        <p className='paragraph'>
          The Company may use various technologies, including cookies, tokens, tags, web logs, web beacons, scripts, and
          web server logs to gather automatically collected information and may aggregate this information from visitors
          of our Online Services or to enable certain features of our Online Services. This information may include
          demographic data, technical information about the technology (e.g., phone, computer) you use to connect to the
          Online Services, web browser information, your IP address, and browsing behavior such as pages visited and how
          often they are visited (collectively, "Activity Information"). We may also use third-party analytics companies
          to provide these services.
          <br></br>
          <br></br>
          We may also allow third parties to use cookies and other technologies to collect Activity Information and to
          track browsing activity over time and across third-party websites such as web browsers used to read our Online
          Services, which websites are referring traffic or linking to our Online Services, and to deliver targeted
          advertisements to you. We do not control these third-party technologies, and their use of such technologies is
          governed by their own privacy policies. For more information about third-party advertising networks and
          similar entities that use these technologies, see youradchoices.com/control, and to opt-out of such ad
          networks' and services' advertising practices, go to optout.aboutads.info and optout.networkadvertising.org/.
          Once you click the links, you may choose to opt out of such advertising from all participating advertising
          companies or only from advertising provided by specific advertising companies. Please note that, to the extent
          advertising technology is integrated into the Online Services, you may still receive advertisements even if
          you opt out of tailored advertising. In that case, the ads will just not be tailored. Also, we do not control
          any of the above opt-out links and are not responsible for any choices you make using these mechanisms or the
          continued availability or accuracy of these mechanisms.
          <br></br>
          <br></br>
          Activity Information is captured using various technologies and may include cookies. "Cookies" are small text
          files that may be placed on your computer or mobile device when you visit an Online Service or click on a URL
          using your web browser. Cookies may include "single-session cookies" which generally record information during
          only a single visit to a website and then are erased, and "persistent" cookies which are generally stored on a
          computer or mobile device unless or until they are deleted or are set to expire. You may disable cookies and
          similar items by adjusting your browser preferences at any time; however, this may limit your ability to take
          advantage of all the features on our Online Services. In addition, you may also have additional means to
          manage the collection of Activity Information by:
          <br></br>
          <br></br>
          <ul className='pargraph'>
            <li>
              Managing the use of "flash" technologies, with the Flash management tools available at Adobe's website;{' '}
            </li>
            <li>Clicking on the "Opt-Out" link at the bottom of the home webpage, if applicable; </li>
            <li>Visiting Google to "Opt-Out" of display advertising or customize Google display network ads;</li>
          </ul>
          <br></br>
          Please note that we do not currently respond to web browser "Do Not Track" signals that provide a method to
          opt out of the collection of Information about online activities over time and across third-party websites or
          online services because, among other reasons, there is no common definition of such signals and no
          industry-accepted standards for how such signals should be interpreted.
          <br></br>
          <br></br>
          We gather Activity Information about you to improve the quality of our services, such as the best method and
          time to contact you. Without limiting the other ways in which we may use Information as described herein, we
          may otherwise use and disclose your Activity Information unless restricted by this Policy or by law. Some
          examples of the ways we use your Activity Information include:
          <br></br>
          <br></br>
          <ul className='pargraph'>
            <li>Customizing your experiences, including managing and recording your preferences; </li>
            <li>Authenticating your account information; </li>
            <li>Marketing, product development, and research purposes;</li>
            <li>Tracking resources and data accessed on the Online Services;</li>
            <li>Developing reports regarding Online Service usage, activity, and statistics;</li>
            <li>Assisting users experiencing problems with our services;</li>
            <li>Updating and servicing our Online Services;</li>
            <li>Enabling certain functions and tools on the Online Services; and</li>
            <li>Tracking paths of visitors to the Online Services and within the Online Services.</li>
          </ul>
          <br></br>
          As described above, we may use tracking technologies that allow us to recognize your device when you return to
          our Online Services within a period of time, as determined by us, and to support automatic login to your
          Online Services. To maintain your privacy, you should affirmatively log out of your account prior to your
          session ending (whether you end your session or we end your session, for example if our Online Services has
          "timed out" - i.e., we have ended your session automatically after a period of inactivity as determined by us
          in our sole discretion). Unless you affirmatively log out of your account, you may be automatically logged
          back in the next time you or any user of your devices visits the Online Services.
        </p>

        <br></br>

        <span className='heading'>Retention of Data</span>
        <p className='paragraph'>
          We will retain your personally identifiable information (PII) and Activity Information for as long as is
          necessary for the purposes set out in this Privacy Policy. We will retain and use your PII to the extent
          necessary to comply with our legal obligations (for example, if we are required to retain your data to comply
          with applicable laws), resolve disputes, and enforce our legal agreements and policies.
        </p>

        <br></br>

        <span className='heading'>Posting Messages, Comments and Content</span>
        <p className='paragraph'>
          Our Online Services may have voluntary collaboration areas, including but not limited to "blogs," "bulletin
          boards," "leader boards," and "health games," that permit users to have collaborative discussions and/or share
          Information. Some of our Online Services may permit you to select a display name or image that will be your
          "nickname" on the Online Service. Please note, any Information you submit or post to these collaboration
          areas, including your display name or image, may be visible by other users of the Online Service, and such
          users may be able to identify you and make information public. Out of respect for the privacy of others,
          please avoid referring to the full names of others in your response and refrain from sharing other
          participants’ identities or comments outside of these discussions.
          <br></br>
          <br></br>
          Also see our Social Media Disclaimer Social Media Disclaimer to learn about our practices related to posting
          on our social media accounts
        </p>

        <br></br>

        <span className='heading'>Protecting Your Information</span>
        <p className='paragraph'>
          We maintain administrative, technical, and physical safeguards designed to protect the Information that you
          provide on our Online Services. These safeguards vary based on the sensitivity of the Information that is
          being collected, used, and stored. We cannot guarantee the security of our Online Services, nor can we
          guarantee the security of the Information you transmit to us over the Internet, including your use of email.
          We are not liable for the illegal acts of third parties such as criminal hackers.
          <br></br>
          <br></br>
          It is your responsibility to safeguard the devices you use to access our Online Services (such as laptops,
          tablets, and mobile devices), and to use appropriate security settings on those devices. If those devices are
          lost, stolen or misplaced, others may be able to access your account and your personal Information using those
          devices. You should affirmatively log out of your account (i) prior to ending your session, or (ii) if you
          will be inactive on the Online Services for more than a few minutes; otherwise, the next user of that computer
          or device, particularly a public one or one not owned by you, may be able to access your account and the
          Information in your account if your session has not ended.
          <br></br>
          <br></br>
          You agree that we are not responsible for any harm that may result from someone accessing your account or
          personal Information on any computer or device where you do not, for any reason, take the necessary steps to
          log out of your account prior to ending a session on such device or computer.
          <br></br>
          <br></br>
          We retain Information for as long as necessary for the purpose for which it is collected, subject to a longer
          period if the Information is relevant to a legal challenge.
        </p>

        <br></br>

        <span className='heading'>Children Under 13</span>
        <p className='paragraph'>
          We will not intentionally collect any personal information (as that term is defined in the Children's Online
          Privacy Protection Act) from children under the age of 13 through our Online Services without receiving
          parental consent. If you think that we have collected such personal information from a child under the age of
          13 through our Online Services, please Contact Us immediately.
        </p>

        <br></br>

        <span className='heading'>Additional Rights for California Resident</span>

        <br></br>

        <span className='heading'>California “Shine the Light” Privacy Rights</span>
        <p className='paragraph'>
          California law permits our customers who are California residents to request certain information regarding the
          disclosure of certain personal information to third parties for their direct marketing purposes.
          <br></br>
          <br></br>
          If we have disclosed any personal information to third parties for direct marketing purposes, we will provide
          a list of the categories of personal information, along with the names and addresses of these third parties to
          you at your request. To make such a request, write us at the postal or email address found in the Contact Us
          section of this Policy.
          <br></br>
          <br></br>
          This request may be made no more than once per calendar year. We reserve our right not to respond to requests
          submitted other than to the specified email or postal address. You should put "California Privacy
          Rights-Direct Marketing" in the email subject line and in the body of your request. You must provide us with
          specific information regarding yourself so that we can accurately respond to the request.
        </p>

        <br></br>

        <span className='heading'>California Minors Under 18</span>
        <p className='paragraph'>
          If you are a California resident under the age of 18 and are a registered user of our Online Services, you may
          request that we remove from our Online Services any content you post to our Online Services that can be
          accessed by any other user (whether registered or not). Please note that any content that is removed from
          visibility on our Online Services may still remain on our servers and in our systems. To request removal of
          content under this provision, please write or email us at the postal or email address found in the Contact Us
          section of this Policy. When you write to us, please provide us with a description of the content and the
          location of the content on our Online Services, along with any other information that we may require to
          consider your request. Please note that removal of content under this provision does not ensure complete or
          comprehensive removal of the content or information posted on the Online Services by you.
        </p>

        <br></br>

        <span className='heading'>Social Media Disclaimer</span>
        <p className='paragraph'>
          Are you using social media? So are we! We encourage you to read, share, follow us and provide commentary on
          Facebook®, Twitter®, Pinterest®, Instagram® and other social media sites ("Social Media Site"). Before you
          post on our pages or accounts, please make sure you read our social media disclaimer:
          <br></br>
          <br></br>
          We are under no obligation to screen or monitor your posts or any other user content; however, we reserve the
          right to monitor participation to ensure that you stay on topic, are courteous and avoid making offensive
          comments. Your posts and user content must adhere to the following requirements and cannot:
          <br></br>
          <br></br>
          <ul className='pargraph'>
            <li>
              Contain any third-party material including logos, drawings, tattoos, photographs, pictures, sculptures,
              paintings and other images or works of art, phrases, trademarks, trade secrets, or other items without
              explicit, prior, written permission to use such materials;
            </li>
            <li>
              Contain sexually explicit, graphic, gratuitous or unnecessarily violent content or defamatory or
              derogatory content against any ethnic, racial, gender, religious, sexual orientation, professional or age
              group, or contain any pornographic or nude material;
            </li>
            <li>
              Contain any private information about yourself or any other individual, including without limitation,
              information related to the health of the individual, financial information about the individual, or any
              identification or account numbers related to the individual, with or without their permission or consent;
            </li>
            <li>
              Contain any software viruses or any other computer code, files or programs designed to interrupt, destroy
              or limit the functionality of any computer software, hardware, or telecommunications equipment; and
            </li>
            <li>
              Contain any advertising, promotional materials, "junk mail," "spam," "chain letters," "pyramid schemes,"
              or promote illegal activity and/or illegal contests, sweepstakes, gambling, including any online casino,
              sports books, bingo, poker, or any other form of solicitation.
            </li>
          </ul>
          <br></br>
          We reserve the right to edit comments for content, remove off-topic contributions, delete offensive comments
          or remarks, block offensive contributors, and delete actual or suspected spam content from any Social Media
          Site. Please be aware that once you post something online, there is the potential for numerous individuals to
          read your words, even years from now. Therefore, we suggest that you exercise caution when posting on any
          Social Media Sites and that you not disclose Information like your location, medical record number, personal
          medical information, financial information, etc. We are not responsible for the content of any comments or
          responses posted by others to any Online Service or Social Media Site we manage or monitor. We do not control
          the placement of any marketing or advertising displayed on our pages by social media or third-party
          organizations.
          <br></br>
          <br></br>
          Please remember that content posted on any of our social media profiles or platforms is for general
          informational purposes only and should not be considered medical advice and should not replace a consultation
          with your health care or financial professional. Always consult an appropriate health care or financial
          professional for your specific needs. If you are experiencing a medical emergency, call 9-1-1 or your local
          emergency number. Some treatments mentioned on social media formats may not be covered by your health plan.
          Please refer to your benefit plan documents for information about coverage.
          <br></br>
          <br></br>
          We reserve the right to respond to any post or user content and may occasionally privately request your
          contact information to assist you offline, with your consent, by routing the matter to the appropriate persons
          or department for further handling. Any further questions about your account, claims or benefits or request
          for additional information can be addressed by visiting your member or patient website or calling the
          toll-free member phone number on your health plan or member ID.
          <br></br>
          <br></br>
          All trademarks are the property of their respective owners.
        </p>

        <br></br>

        <span className='heading'>Social Security Number Protection Policy</span>
        <p className='paragraph'>
          It is our policy to protect the confidentiality of Social Security numbers (“SSNs”) that we receive or collect
          in the course of business. We secure the confidentiality of SSNs through various means, including physical,
          technical, and administrative safeguards that are designed to protect against unauthorized access. It is our
          policy to limit access to SSNs to that which is lawful and to prohibit unlawful disclosure of SSNs.
        </p>

        <br></br>

        <span className='heading'>Changes to This Policy</span>
        <p className='paragraph'>
          We may change this Policy at any time. If we do so, such change will appear on this page. You may always visit
          this Policy to learn of any updates. Your continued access to or use of the Online Services constitutes your
          consent to these changes to this Policy
        </p>

        <br></br>

        <span className='heading'>Contact Us</span>
        <p className='paragraph'>
          Contact us regarding this Policy or related privacy practices. If you believe we or any company associated
          with us has misused your Information, please contact us immediately.
          <br></br>
          <br></br>
          Online support : Submit a request by visiting the Optum community at
          https://optuminsightprovidersupport.force.com and entering your OHID credentials. New OHID users can also
          register for OHID on this site. If you do not have access to the portal, please contact your manager to submit
          a request for access on your behalf or contact us by phone
          <br></br>
          <br></br>
          Phone: Speak with a live agent by dialing 1-866-678-8646 and selecting Option 7.
        </p>

        <span>Optum Privacy Office</span>
        <br></br>
        <span>MN101-E013, 11000 Optum Circle</span>
        <br></br>
        <span>Eden Prairie, MN 55344</span>
        <br></br>
        <span>privacy@optum.com</span>
        <br></br>
        <br></br>

        <span className='heading'>Effective Date: 30th July 2024</span>
      </div>
    </>
  );
};

export default PrivacyPolicy;
